import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { DisclosureFeatureControlService } from '../disclosure-feature-control-service';
import { SharePageService } from '@/services/share-page/share-page-service';


@injectable()
export class DisclosureFeatureControlServiceImpl implements DisclosureFeatureControlService {
    constructor(
        @inject(SharePageService)
        private readonly _sharePageService: SharePageService,
    ) { }

    get isOptimizationEnabled(){
        return !this._sharePageService.isSharePage;
    }

    get isEditEnabled(){
        return !this._sharePageService.isSharePage;
    }

    get isHiddenEnabled(){
        return !this._sharePageService.isSharePage;
    }

    get isContentAdjustmentEnabled(){
        return !this._sharePageService.isSharePage;
    }

    get isCreateNewTaskEnabled(){
        return !this._sharePageService.isSharePage;
    }

    get isExportEnabled(){
        return !this._sharePageService.isSharePage;
    }

}
